import React, { useEffect, useState } from "react";
import { Box, Button, Heading, Text } from "@chakra-ui/react";
import { useLocation, useHistory } from "react-router-dom/";
import { useLazyQuery } from "@apollo/client";
import { format } from "date-fns";
import { QSETS } from "../../graphql/queries";
import { PaginatedDataTable } from "../../components/PaginatedDataTable";
import { ArrowForwardIcon } from "@chakra-ui/icons";
import {
  getAvgTimeTakenPerQuestion,
  secondsToMinutesAndSeconds,
} from "../../utils/helper";

export const PreviousTestsPage = ({ user, userRole, loadingCallback }) => {
  const [qsets, setQsets] = useState([]);
  const { search } = useLocation();
  const queryParams = new URLSearchParams(search);
  const appid = queryParams.get("appid");
  const userid = queryParams.get("userid");
  const history = useHistory();

  const [getQsets] = useLazyQuery(QSETS, {
    onCompleted: (data) => {
      setQsets(
        data?.qsets.map((qset) => {
          const submission =
            qset?.qSetSubmissions.length > 0 ? qset?.qSetSubmissions[0] : {};
          const totalQuestions = submission.id
            ? submission?.qset?.dynosUnderQSet.length
            : null;
          return {
            ...qset,
            name: qset?.qSetName,
            submittedAt: submission?.id
              ? format(new Date(submission?.updatedAt), "MM/dd/yyyy")
              : null,
            score: submission?.id
              ? `${submission?.qsetScore}/${totalQuestions}`
              : null,
            totalTimeTaken: submission?.id
              ? secondsToMinutesAndSeconds(submission?.qsetTimeTaken)
              : null,
            avgTimeTaken: submission?.id
              ? getAvgTimeTakenPerQuestion(
                  Number(submission?.qsetTimeTaken),
                  Number(totalQuestions),
                )
              : null,
            status: submission?.id
              ? submission?.isAllQuestionSubmitted
                ? "Practice Again"
                : "Continue"
              : "Try Now",
          };
        }),
      );
      loadingCallback(false, "");
    },
    onError: () => {
      loadingCallback(false, "");
    },
  });

  useEffect(() => {
    loadingCallback(true, "loading previous tests...");
    getQsets({
      variables: {
        where: {
          AND: [
            {
              QApp: {
                id: { equals: appid },
              },
            },
            {
              userId: {
                equals: userid,
              },
            },
          ],
        },
      },
    });
  }, [appid, userid, getQsets, loadingCallback]);

  const practiceQset = (value) => {
    history.push(`/qviewer?appid=${appid}&userid=${userid}&qsetid=${value.id}`);
  };

  const qsetColumns = [
    {
      Header: "Name",
      accessor: "name",
      Cell: ({ cell: { value } }) => <Text>{value}</Text>,
    },
    {
      Header: "Date Of Test",
      accessor: "submittedAt",
      Cell: ({ cell: { value } }) => <Text>{value ? value : "-"}</Text>,
    },
    {
      Header: "Score",
      accessor: "score",
      Cell: ({ cell: { value } }) => <Text>{value ? value : "-"}</Text>,
    },
    {
      Header: "Total Time Taken",
      accessor: "totalTimeTaken",
      Cell: ({ cell: { value } }) => <Text>{value ? value : "-"}</Text>,
    },
    {
      Header: "Avg Time Per Question",
      accessor: "avgTimeTaken",
      Cell: ({ cell: { value } }) => <Text>{value ? value : "-"}</Text>,
    },
    ...(userRole === "Student"
      ? [
          {
            Header: "Practice",
            Cell: ({ cell }) => {
              return (
                <Button
                  variant="ghost"
                  colorScheme="brand"
                  aria-label="practice"
                  onClick={() => practiceQset(cell.row.original)}
                  rightIcon={<ArrowForwardIcon />}
                >
                  {cell.row.original.status}
                </Button>
              );
            },
          },
        ]
      : []),
  ];

  return (
    <Box padding={{ base: "20px 10px", md: "20px 20px" }}>
      <Heading
        as="h2"
        size="md"
        sx={{
          textAlign: "center",
          textTransform: "uppercase",
          margin: {
            sm: "10px 0",
            md: "20px 0",
          },
        }}
      >
        Study from previous tests
      </Heading>
      <PaginatedDataTable
        columns={qsetColumns}
        data={qsets}
        showNumberOfRecords={100}
      />
    </Box>
  );
};
